import { useState } from 'react'
import { Link } from 'react-router-dom'

import { requestPasswordReset } from '../auth'
import { AnonymousShell } from '../components/AnonymousShell'
import { useAction } from '../hooks/useAction'

/** PUBLIC: ask for a password-reset email. The server answers the same
 *  whether or not the address has an account, so this page always reports
 *  "check your inbox" — never whether the email is known. */
export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const { busy, error, run } = useAction()

  return (
    <AnonymousShell>
      <div className="auth-card" data-testid="forgot-password-page">
        <h1>Reset your password</h1>
        {sent ? (
          <p data-testid="forgot-password-sent">
            If an account exists for <strong>{email.trim()}</strong>, we've emailed a link to
            reset its password. The link expires in an hour.
          </p>
        ) : (
          <form
            className="login-password-form"
            onSubmit={(e) => {
              e.preventDefault()
              void run(async () => {
                await requestPasswordReset(email.trim())
                setSent(true)
              }, { errorMessage: (err) => (err as Error).message })
            }}
          >
            <p>Enter the email you sign in with and we'll send you a reset link.</p>
            <label>
              Email
              <input
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-password-email"
                required
              />
            </label>
            <button type="submit" className="primary" disabled={busy || !email.trim()} data-testid="forgot-password-submit">
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
            {error && (
              <div className="notice notice--error" role="alert">
                {error}
              </div>
            )}
          </form>
        )}
        <p style={{ marginTop: '1.5rem' }}>
          <Link to="/login">← Back to sign in</Link>
        </p>
      </div>
    </AnonymousShell>
  )
}
